export default [
    {
        componente : 'rol',
        titulo : 'ROL',
        esconderTitulo : false,
        chavePermissao : "MovimentacaoFinanceiraRol"
    },
    {
        componente : 'anexo2',
        titulo : 'ANEXO 2',
        esconderTitulo : false,
        chavePermissao : "MovimentacaoFinanceiraAnexo2"
    },
    {
        componente : 'anexo6_1',
        titulo : 'ANEXO 6.1',
        esconderTitulo : false,
        chavePermissao : "MovimentacaoFinanceiraAnexo61"
    },
    {
        componente : 'anexo6_2',
        titulo : 'ANEXO 6.2',
        esconderTitulo : false,
        chavePermissao : "MovimentacaoFinanceiraAnexo62"
    },
    {
        componente : 'grafico',
        titulo : 'GRÁFICO',
        esconderTitulo : false,
        chavePermissao : "MovimentacaoFinanceiraGrafico"
    },
    
    
]